module.exports = __webpack_public_path__ + "img/newhome.1263e6d0.png";